export enum GlobalPartnerTypes {
  Distributor = 'Distributor',
  Commercial = 'Commercial',
  Retailer = 'Retailer',
}
